import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { UpdateUserAccountBody } from "@shared-kernel/application/ports/admin/admin-repository";

export interface UpdateUserAccountParams {
  userId: string;
  body: UpdateUserAccountBody;
}

export const updateUserAccount = createApiThunk<string, UpdateUserAccountParams>(
  "admin/users/updateAccount",
  async ({ userId, body }, { extra: { adminRepository } }) => {
    await adminRepository!.updateUserAccount(userId, body);
    return userId;
  },
);

export const resetUpdateUserAccount = createAction("admin/users/resetUpdateAccount");
